import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { ScrollArea } from './ui/scroll-area';
import { BooksDecisionBanner } from './BooksDecisionBanner';
import axios from 'axios';
import {
    Home, Users, GraduationCap, BookOpen, Calendar, CreditCard,
    Bell, Settings, LogOut, Menu, X, ChevronDown, ChevronRight,
    UserCheck, ClipboardList, Award, FileText, Clock, Activity,
    Building, Layers, DollarSign, UserPlus, UserMinus, UserX, CheckSquare, AlertCircle, Phone, Wallet, History, Eye, Heart, MessageSquare, Send, PieChart, CalendarClock, BookMarked, Search
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_LOGO = null;

export const menuItems = {
    super_admin: [
        { label: 'Dashboard', icon: Home, path: '/admin' },
        { label: 'Search', icon: Search, path: '/admin/search' },
        { label: 'Users', icon: Users, path: '/admin/users' },
        { label: 'Parents', icon: UserCheck, path: '/admin/parents' },
        { label: 'Students', icon: GraduationCap, path: '/admin/students' },
        { label: 'All Students', icon: GraduationCap, path: '/admin/all-students' },
        { label: 'Teachers', icon: BookOpen, path: '/admin/teachers' },
        { label: 'Programs', icon: Building, path: '/admin/programs' },
        { label: 'Classes', icon: Layers, path: '/admin/classes' },
        { label: 'Curriculum', icon: BookMarked, path: '/admin/curriculum' },
        { label: 'Waiting List', icon: UserPlus, path: '/admin/waiting-list' },
        { label: 'Pending List', icon: Clock, path: '/admin/pending-list' },
        { label: 'Unregistered', icon: UserMinus, path: '/admin/unregistered' },
        { label: "Didn't Renew", icon: UserX, path: '/admin/didnt-renew' },
        { label: 'Attendance', icon: CheckSquare, path: '/admin/attendance' },
        { label: 'Homework', icon: ClipboardList, path: '/admin/homework' },
        { label: 'Exams', icon: FileText, path: '/admin/exams' },
        { label: 'Quran Awards', icon: Award, path: '/admin/awards' },
        { label: 'Fee Bands', icon: DollarSign, path: '/admin/fee-bands' },
        { label: 'Payments', icon: CreditCard, path: '/admin/payments' },
        { label: 'Unpaid Guardians', icon: AlertCircle, path: '/admin/unpaid-guardians' },
        { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
        { label: 'Activities', icon: Activity, path: '/admin/activities' },
        { label: 'Leave Requests', icon: Clock, path: '/admin/leave-requests' },
        { label: 'Calendar', icon: Calendar, path: '/admin/calendar' },
        { label: 'Call Log', icon: Phone, path: '/admin/calls' },
        { label: 'SMS Center', icon: MessageSquare, path: '/admin/sms' },
        { label: 'Communications', icon: Send, path: '/admin/communications' },
        { label: 'PTM', icon: CalendarClock, path: '/admin/ptm' },
        { label: 'Salaries', icon: Wallet, path: '/admin/salaries' },
        { label: 'Financial Status', icon: PieChart, path: '/admin/financial-status' },
        { label: 'Books Storage', icon: BookOpen, path: '/admin/books' },
        { label: 'Book Receiving', icon: BookOpen, path: '/admin/book-receiving' },
        { label: 'Donations', icon: Heart, path: '/admin/donations' },
        { label: 'Policies', icon: FileText, path: '/admin/policies' },
        { label: 'Settings', icon: Settings, path: '/admin/settings' },
        { label: 'View As', icon: Eye, path: '/admin/view-as' },
    ],
    manager: [
        { label: 'Dashboard', icon: Home, path: '/manager' },
        { label: 'Search', icon: Search, path: '/manager/search' },
        { label: 'Users', icon: Users, path: '/manager/users' },
        { label: 'Parents', icon: UserCheck, path: '/manager/parents' },
        { label: 'Students', icon: GraduationCap, path: '/manager/students' },
        { label: 'All Students', icon: GraduationCap, path: '/manager/all-students' },
        { label: 'Teachers', icon: BookOpen, path: '/manager/teachers' },
        { label: 'Programs', icon: Building, path: '/manager/programs' },
        { label: 'Classes', icon: Layers, path: '/manager/classes' },
        { label: 'Curriculum', icon: BookMarked, path: '/manager/curriculum' },
        { label: 'Homework', icon: ClipboardList, path: '/manager/homework' },
        { label: 'Waiting List', icon: UserPlus, path: '/manager/waiting-list' },
        { label: 'Pending List', icon: Clock, path: '/manager/pending-list' },
        { label: 'Unregistered', icon: UserMinus, path: '/manager/unregistered' },
        { label: "Didn't Renew", icon: UserX, path: '/manager/didnt-renew' },
        { label: 'Fee Bands', icon: DollarSign, path: '/manager/fee-bands' },
        { label: 'Payments', icon: CreditCard, path: '/manager/payments' },
        { label: 'Unpaid Guardians', icon: AlertCircle, path: '/manager/unpaid-guardians' },
        { label: 'Finance', icon: DollarSign, path: '/manager/finance' },
        { label: 'Activities', icon: Activity, path: '/manager/activities' },
        { label: 'Leave Requests', icon: Clock, path: '/manager/leave-requests' },
        { label: 'Calendar', icon: Calendar, path: '/manager/calendar' },
        { label: 'Call Log', icon: Phone, path: '/manager/calls' },
        { label: 'SMS Center', icon: MessageSquare, path: '/manager/sms' },
        { label: 'Communications', icon: Send, path: '/manager/communications' },
        { label: 'PTM', icon: CalendarClock, path: '/manager/ptm' },
        { label: 'Salaries', icon: Wallet, path: '/manager/salaries' },
    ],
    branch_manager: [
        { label: 'Dashboard', icon: Home, path: '/manager' },
        { label: 'Search', icon: Search, path: '/manager/search' },
        { label: 'Parents', icon: UserCheck, path: '/manager/parents' },
        { label: 'Students', icon: GraduationCap, path: '/manager/students' },
        { label: 'All Students', icon: GraduationCap, path: '/manager/all-students' },
        { label: 'Teachers', icon: BookOpen, path: '/manager/teachers' },
        { label: 'Classes', icon: Layers, path: '/manager/classes' },
        { label: 'Curriculum', icon: BookMarked, path: '/manager/curriculum' },
        { label: 'Homework', icon: ClipboardList, path: '/manager/homework' },
        { label: 'Waiting List', icon: UserPlus, path: '/manager/waiting-list' },
        { label: 'Pending List', icon: Clock, path: '/manager/pending-list' },
        { label: 'Unregistered', icon: UserMinus, path: '/manager/unregistered' },
        { label: "Didn't Renew", icon: UserX, path: '/manager/didnt-renew' },
        { label: 'Payments', icon: CreditCard, path: '/manager/payments' },
        { label: 'Unpaid Guardians', icon: AlertCircle, path: '/manager/unpaid-guardians' },
        { label: 'Activities', icon: Activity, path: '/manager/activities' },
        { label: 'Calendar', icon: Calendar, path: '/manager/calendar' },
        { label: 'Call Log', icon: Phone, path: '/manager/calls' },
    ],
    teacher: [
        { label: 'Dashboard', icon: Home, path: '/teacher' },
        { label: 'My Students', icon: GraduationCap, path: '/teacher/students' },
        { label: 'Attendance', icon: CheckSquare, path: '/teacher/attendance' },
        { label: 'Timetable', icon: Calendar, path: '/teacher/timetable' },
        { label: 'Homework', icon: ClipboardList, path: '/teacher/homework' },
        { label: 'Exams', icon: FileText, path: '/teacher/exams' },
        { label: 'Student of Month', icon: Award, path: '/teacher/student-of-month' },
        { label: 'Hours Counter', icon: Clock, path: '/teacher/hours' },
        { label: 'My Salary', icon: Wallet, path: '/teacher/salary' },
        { label: 'PTM Bookings', icon: CalendarClock, path: '/teacher/ptm' },
        { label: 'Special Arabic', icon: BookOpen, path: '/teacher/special-arabic' },
        { label: 'Books', icon: BookOpen, path: '/teacher/books' },
        { label: 'Policies', icon: FileText, path: '/teacher/policies' },
        { label: 'Leave Requests', icon: Clock, path: '/teacher/leave' },
        { label: 'Documents', icon: FileText, path: '/teacher/documents' },
        { label: 'Calendar', icon: Calendar, path: '/teacher/calendar' },
    ],
    parent: [
        { label: 'Dashboard', icon: Home, path: '/parent' },
        { label: 'My Details', icon: UserCheck, path: '/parent/details' },
        { label: 'My Students', icon: GraduationCap, path: '/parent/children' },
        { label: 'Attendance', icon: CheckSquare, path: '/parent/attendance' },
        { label: 'Homework', icon: ClipboardList, path: '/parent/homework' },
        { label: 'Grades', icon: FileText, path: '/parent/grades' },
        { label: 'Fees & Payments', icon: CreditCard, path: '/parent/payments' },
        { label: 'Renewal', icon: Activity, path: '/parent/renewal' },
        { label: 'Activities', icon: Calendar, path: '/parent/activities' },
        { label: 'PTM Booking', icon: CalendarClock, path: '/parent/ptm' },
        { label: 'Previous Years', icon: History, path: '/parent/previous-years' },
        { label: 'Collectors', icon: Users, path: '/parent/collectors' },
        { label: 'Policies', icon: FileText, path: '/parent/policies' },
        { label: 'Calendar', icon: Calendar, path: '/parent/calendar' },
    ]
};

const DashboardLayout = ({ children }) => {
    const { user, logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO);
    const [hiddenPaths, setHiddenPaths] = useState([]);

    const role = user?.role || 'parent';
    const baseItems = menuItems[role] || menuItems.parent;
    const [showPreviousYears, setShowPreviousYears] = useState(false);
    // Branch Managers get a per-user override list from the user doc.
    const userHiddenPaths = role === 'branch_manager' ? (user?.sidebar_hidden_paths || []) : [];
    const items = role === 'super_admin'
        ? baseItems
        : baseItems
            .filter(i => !hiddenPaths.includes(i.path))
            .filter(i => !userHiddenPaths.includes(i.path))
            .filter(i => i.path !== '/parent/previous-years' || showPreviousYears);

    useEffect(() => {
        const fetchUnreadCount = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/notifications/unread-count`, { withCredentials: true });
                setUnreadCount(response.data.count);
            } catch (error) {
                console.error('Failed to fetch unread count:', error);
            }
        };
        const fetchLogo = async () => {
            try {
                const res = await axios.get(`${API_URL}/api/settings`, { withCredentials: true });
                if (res.data?.logo_url) setLogoUrl(res.data.logo_url);
                const vis = res.data?.sidebar_visibility || {};
                if (role in vis && Array.isArray(vis[role])) setHiddenPaths(vis[role]);
                setShowPreviousYears(!!res.data?.show_previous_years_to_parents);
            } catch (err) {
                console.debug('settings/logo fetch failed:', err?.message);
            }
        };

        fetchUnreadCount();
        fetchLogo();
        const interval = setInterval(() => { fetchUnreadCount(); fetchLogo(); }, 30000);
        return () => clearInterval(interval);
    }, [role, location.pathname]);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const homePath = `/${role === 'super_admin' ? 'admin' : role === 'branch_manager' ? 'manager' : role}`;
    const isActive = (path) => {
        if (path === homePath) {
            return location.pathname === path;
        }
        return location.pathname.startsWith(path);
    };

    return (
        <div className="min-h-screen bg-[#FAF9F6]">
            {user?._impersonating && (
                <div className="fixed top-0 left-0 right-0 z-[100] bg-[#F59E0B] text-white text-sm px-4 py-2 flex items-center justify-between shadow-md" data-testid="impersonation-banner">
                    <span>
                        <strong>Viewing as {user.first_name} {user.last_name}</strong>
                        {user._impersonator ? ` — original session: ${user._impersonator.first_name} ${user._impersonator.last_name}` : ''}
                    </span>
                    <button
                        className="bg-white text-[#B45309] font-semibold rounded px-3 py-1 hover:bg-[#FEF3C7]"
                        onClick={async () => {
                            try {
                                await axios.post(`${API_URL}/api/auth/exit-impersonation`, {}, { withCredentials: true });
                                window.location.href = '/admin';
                            } catch { /* ignore */ }
                        }}
                        data-testid="exit-impersonation-btn"
                    >Exit</button>
                </div>
            )}
            <div className={user?._impersonating ? 'pt-9' : ''}>
            {/* Mobile Header */}
            <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-black/5 px-4 py-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}
                            className="p-2 rounded-lg hover:bg-black/5"
                            data-testid="mobile-menu-button"
                        >
                            {mobileSidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                        </button>
                        {logoUrl ? <img src={logoUrl} alt="Logo" className="h-8 w-8 rounded" /> : <div className="h-8 w-8 rounded bg-[#064E3B] flex items-center justify-center text-white font-bold text-xs">NHQ</div>}
                        <span className="font-semibold text-[#1F2937] font-['Outfit']">NHQ</span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <Link
                            to={`${homePath}/notifications`}
                            className="relative p-2 rounded-lg hover:bg-black/5"
                            data-testid="notifications-button"
                        >
                            <Bell className="h-5 w-5 text-[#4B5563]" />
                            {unreadCount > 0 && (
                                <span className="absolute top-1 right-1 h-4 w-4 bg-[#EF4444] text-white text-xs rounded-full flex items-center justify-center">
                                    {unreadCount > 9 ? '9+' : unreadCount}
                                </span>
                            )}
                        </Link>
                    </div>
                </div>
            </div>

            {/* Mobile Sidebar Overlay */}
            {mobileSidebarOpen && (
                <div
                    className="lg:hidden fixed inset-0 z-40 bg-black/50"
                    onClick={() => setMobileSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`fixed top-0 left-0 z-50 h-full bg-white border-r border-black/5 transition-all duration-300 
                    ${sidebarOpen ? 'w-64' : 'w-20'} 
                    ${mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
            >
                {/* Logo Section */}
                <div className="h-16 flex items-center justify-between px-4 border-b border-black/5">
                    <Link to={homePath} className="flex items-center space-x-3">
                        {logoUrl ? <img src={logoUrl} alt="Logo" className="h-10 w-10 rounded" /> : <div className="h-10 w-10 rounded bg-[#064E3B] flex items-center justify-center text-white font-bold text-sm">NHQ</div>}
                        {sidebarOpen && (
                            <span className="font-semibold text-[#1F2937] font-['Outfit'] whitespace-nowrap">
                                Nurulhuda
                            </span>
                        )}
                    </Link>
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="hidden lg:block p-1.5 rounded-lg hover:bg-black/5"
                        data-testid="sidebar-toggle"
                    >
                        {sidebarOpen ? <ChevronDown className="h-4 w-4 rotate-90" /> : <ChevronRight className="h-4 w-4" />}
                    </button>
                </div>

                {/* User Info */}
                <div className={`px-4 py-4 border-b border-black/5 ${!sidebarOpen && 'hidden lg:block'}`}>
                    <div className="flex items-center space-x-3">
                        <div className="h-10 w-10 rounded-full bg-[#064E3B] flex items-center justify-center text-white font-medium">
                            {user?.first_name?.[0]}{user?.last_name?.[0]}
                        </div>
                        {sidebarOpen && (
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-[#1F2937] truncate">
                                    {user?.first_name} {user?.last_name}
                                </p>
                                <p className="text-xs text-[#4B5563] capitalize">
                                    {role.replace('_', ' ')}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Navigation */}
                <ScrollArea className="h-[calc(100vh-200px)]">
                    <nav className="p-3 space-y-1">
                        {items.map((item) => {
                            const Icon = item.icon;
                            const active = isActive(item.path);
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    onClick={() => setMobileSidebarOpen(false)}
                                    className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-colors ${
                                        active
                                            ? 'bg-[#064E3B] text-white'
                                            : 'text-[#4B5563] hover:bg-black/5 hover:text-[#1F2937]'
                                    } ${!sidebarOpen && 'justify-center'}`}
                                    data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                                >
                                    <Icon className="h-5 w-5 flex-shrink-0" />
                                    {sidebarOpen && (
                                        <span className="text-sm font-medium">{item.label}</span>
                                    )}
                                </Link>
                            );
                        })}
                    </nav>
                </ScrollArea>

                {/* Bottom Section */}
                <div className="absolute bottom-0 left-0 right-0 p-3 border-t border-black/5">
                    <button
                        onClick={handleLogout}
                        className={`flex items-center space-x-3 w-full px-3 py-2.5 rounded-lg text-[#EF4444] hover:bg-red-50 transition-colors ${
                            !sidebarOpen && 'justify-center'
                        }`}
                        data-testid="logout-button"
                    >
                        <LogOut className="h-5 w-5" />
                        {sidebarOpen && <span className="text-sm font-medium">Logout</span>}
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main
                className={`transition-all duration-300 pt-16 lg:pt-0 ${
                    sidebarOpen ? 'lg:ml-64' : 'lg:ml-20'
                }`}
            >
                {/* Desktop Header */}
                <header className="hidden lg:flex h-16 items-center justify-between px-6 bg-white border-b border-black/5 sticky top-0 z-40">
                    <div className="flex items-center space-x-4">
                        <h1 className="text-lg font-semibold text-[#1F2937] font-['Outfit']">
                            {items.find(i => isActive(i.path))?.label || 'Dashboard'}
                        </h1>
                    </div>
                    <div className="flex items-center space-x-3">
                        <Link
                            to={`${homePath}/notifications`}
                            className="relative p-2 rounded-lg hover:bg-black/5 transition-colors"
                            data-testid="desktop-notifications"
                        >
                            <Bell className="h-5 w-5 text-[#4B5563]" />
                            {unreadCount > 0 && (
                                <span className="absolute top-1 right-1 h-4 w-4 bg-[#EF4444] text-white text-xs rounded-full flex items-center justify-center">
                                    {unreadCount > 9 ? '9+' : unreadCount}
                                </span>
                            )}
                        </Link>
                    </div>
                </header>

                {/* Page Content */}
                <div className="p-4 lg:p-6 min-h-[calc(100vh-8rem)]">
                    {role === 'parent' && <BooksDecisionBanner />}
                    {children}
                </div>

                {/* Footer */}
                <footer className="border-t border-black/5 bg-white px-6 py-4">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#4B5563]">
                        <div className="flex items-center gap-2">
                            {logoUrl ? <img src={logoUrl} alt="Logo" className="h-6 w-6 rounded" /> : <div className="h-6 w-6 rounded bg-[#064E3B] flex items-center justify-center text-white font-bold text-[8px]">NHQ</div>}
                            <span>Nurulhuda Quranic School</span>
                        </div>
                        <span>&copy; {new Date().getFullYear()} All rights reserved</span>
                    </div>
                </footer>
            </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
